import { Component } from '@angular/core';

@Component({
  selector: 'ui-panel-header',
  templateUrl: './panel-header.component.html'
})
export class PanelHeaderComponent {

}